import { i18n } from "../../i18n";

// Called from a plain validator, not a component — hence the i18next
// singleton rather than the useTranslation hook.

// Alphanumeric (alpha) sender: up to 11 chars — letters, digits, and "-" / "_".
const ALPHANUMERIC_SENDER = /^[A-Za-z0-9_-]{1,11}$/;
// Numeric sender: up to 16 digits, optionally in E.164 form (leading "+").
const NUMERIC_SENDER = /^\+?[0-9]{1,16}$/;

export function validateSenderId(value: string): string | undefined {
  const trimmed = value.trim();
  if (!trimmed) {
    return i18n.t("settings.senderId.required") as string;
  }
  if (NUMERIC_SENDER.test(trimmed) || ALPHANUMERIC_SENDER.test(trimmed)) {
    return undefined;
  }
  if (/^\+?[0-9]+$/.test(trimmed)) {
    return i18n.t("settings.senderId.tooManyDigits") as string;
  }
  return i18n.t("settings.senderId.tooLong") as string;
}
